import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';
import { useSelect } from '@wordpress/data';

export default function Edit({ attributes, setAttributes }) {
    const { id_mini_header_barre_oblique_element_1_icone_1Id, id_mini_header_barre_oblique_element_1_icone_1Alt, id_mini_header_barre_oblique_element_1_icone_1Opacite, id_mini_header_barre_oblique_element_1_icone_1Afficher, id_mini_header_barre_oblique_element_1_texte_1Texte, id_mini_header_barre_oblique_element_1_texte_1CouleurTexte, id_mini_header_barre_oblique_element_1_texte_1Opacite, id_mini_header_barre_oblique_element_1_texte_1Afficher, id_mini_header_barre_oblique_element_1_icone_2Id, id_mini_header_barre_oblique_element_1_icone_2Alt, id_mini_header_barre_oblique_element_1_icone_2Opacite, id_mini_header_barre_oblique_element_1_icone_2Afficher, id_mini_header_barre_oblique_element_2_icone_1Id, id_mini_header_barre_oblique_element_2_icone_1Alt, id_mini_header_barre_oblique_element_2_icone_1Opacite, id_mini_header_barre_oblique_element_2_icone_1Afficher, id_mini_header_barre_oblique_element_2_texte_1Texte, id_mini_header_barre_oblique_element_2_texte_1CouleurTexte, id_mini_header_barre_oblique_element_2_texte_1Opacite, id_mini_header_barre_oblique_element_2_texte_1Afficher, id_mini_header_barre_oblique_element_2_icone_2Id, id_mini_header_barre_oblique_element_2_icone_2Alt, id_mini_header_barre_oblique_element_2_icone_2Opacite, id_mini_header_barre_oblique_element_2_icone_2Afficher, id_mini_header_barre_oblique_element_3_icone_1Id, id_mini_header_barre_oblique_element_3_icone_1Alt, id_mini_header_barre_oblique_element_3_icone_1Opacite, id_mini_header_barre_oblique_element_3_icone_1Afficher, id_mini_header_barre_oblique_element_3_texte_1Texte, id_mini_header_barre_oblique_element_3_texte_1CouleurTexte, id_mini_header_barre_oblique_element_3_texte_1Opacite, id_mini_header_barre_oblique_element_3_texte_1Afficher, id_mini_header_barre_oblique_element_3_icone_2Id, id_mini_header_barre_oblique_element_3_icone_2Alt, id_mini_header_barre_oblique_element_3_icone_2Opacite, id_mini_header_barre_oblique_element_3_icone_2Afficher, id_card_1_titre_1Texte, id_card_1_titre_1CouleurTexte, id_card_1_titre_1Opacite, id_card_1_titre_1Afficher, id_card_1_paragraphe_1Texte, id_card_1_paragraphe_1CouleurTexte, id_card_1_paragraphe_1Opacite, id_card_1_paragraphe_1Afficher, id_card_2_titre_1Texte, id_card_2_titre_1CouleurTexte, id_card_2_titre_1Opacite, id_card_2_titre_1Afficher, id_card_2_paragraphe_1Texte, id_card_2_paragraphe_1CouleurTexte, id_card_2_paragraphe_1Opacite, id_card_2_paragraphe_1Afficher, id_card_3_titre_1Texte, id_card_3_titre_1CouleurTexte, id_card_3_titre_1Opacite, id_card_3_titre_1Afficher, id_card_3_paragraphe_1Texte, id_card_3_paragraphe_1CouleurTexte, id_card_3_paragraphe_1Opacite, id_card_3_paragraphe_1Afficher, id_card_4_titre_1Texte, id_card_4_titre_1CouleurTexte, id_card_4_titre_1Opacite, id_card_4_titre_1Afficher, id_card_4_paragraphe_1Texte, id_card_4_paragraphe_1CouleurTexte, id_card_4_paragraphe_1Opacite, id_card_4_paragraphe_1Afficher, id_card_5_titre_1Texte, id_card_5_titre_1CouleurTexte, id_card_5_titre_1Opacite, id_card_5_titre_1Afficher, id_card_5_paragraphe_1Texte, id_card_5_paragraphe_1CouleurTexte, id_card_5_paragraphe_1Opacite, id_card_5_paragraphe_1Afficher, id_card_6_titre_1Texte, id_card_6_titre_1CouleurTexte, id_card_6_titre_1Opacite, id_card_6_titre_1Afficher, id_card_6_paragraphe_1Texte, id_card_6_paragraphe_1CouleurTexte, id_card_6_paragraphe_1Opacite, id_card_6_paragraphe_1Afficher, blocCouleurFond, blocCouleurBordure, blocImageFondId, animCode } = attributes;

    // Récupération dynamique et réactive des URLs avec useSelect
    const { imageUrl, id_mini_header_barre_oblique_element_1_icone_1ImageUrl, id_mini_header_barre_oblique_element_1_icone_2ImageUrl, id_mini_header_barre_oblique_element_2_icone_1ImageUrl, id_mini_header_barre_oblique_element_2_icone_2ImageUrl, id_mini_header_barre_oblique_element_3_icone_1ImageUrl, id_mini_header_barre_oblique_element_3_icone_2ImageUrl } = useSelect( ( select ) => {
        const media = select( 'core' );
        return {
            imageUrl: blocImageFondId ? media.getMedia( blocImageFondId )?.source_url : null,
            id_mini_header_barre_oblique_element_1_icone_1ImageUrl: id_mini_header_barre_oblique_element_1_icone_1Id ? media.getMedia( id_mini_header_barre_oblique_element_1_icone_1Id )?.source_url : null,
            id_mini_header_barre_oblique_element_1_icone_2ImageUrl: id_mini_header_barre_oblique_element_1_icone_2Id ? media.getMedia( id_mini_header_barre_oblique_element_1_icone_2Id )?.source_url : null,
            id_mini_header_barre_oblique_element_2_icone_1ImageUrl: id_mini_header_barre_oblique_element_2_icone_1Id ? media.getMedia( id_mini_header_barre_oblique_element_2_icone_1Id )?.source_url : null,
            id_mini_header_barre_oblique_element_2_icone_2ImageUrl: id_mini_header_barre_oblique_element_2_icone_2Id ? media.getMedia( id_mini_header_barre_oblique_element_2_icone_2Id )?.source_url : null,
            id_mini_header_barre_oblique_element_3_icone_1ImageUrl: id_mini_header_barre_oblique_element_3_icone_1Id ? media.getMedia( id_mini_header_barre_oblique_element_3_icone_1Id )?.source_url : null,
            id_mini_header_barre_oblique_element_3_icone_2ImageUrl: id_mini_header_barre_oblique_element_3_icone_2Id ? media.getMedia( id_mini_header_barre_oblique_element_3_icone_2Id )?.source_url : null
        };
    }, [ blocImageFondId, id_mini_header_barre_oblique_element_1_icone_1Id, id_mini_header_barre_oblique_element_1_icone_2Id, id_mini_header_barre_oblique_element_2_icone_1Id, id_mini_header_barre_oblique_element_2_icone_2Id, id_mini_header_barre_oblique_element_3_icone_1Id, id_mini_header_barre_oblique_element_3_icone_2Id ] );

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = imageUrl 
        ? { 
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{``}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {imageUrl ? (
                                        <div>
                                            <img src={imageUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="icone-1 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_mini_header_barre_oblique_element_1_icone_1Afficher}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_1_icone_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_mini_header_barre_oblique_element_1_icone_1Alt}
                            onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_1_icone_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_mini_header_barre_oblique_element_1_icone_1Opacite}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_1_icone_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_mini_header_barre_oblique_element_1_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_1_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_mini_header_barre_oblique_element_1_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_1_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_mini_header_barre_oblique_element_1_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_1_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="icone-2 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_mini_header_barre_oblique_element_1_icone_2Afficher}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_1_icone_2Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_mini_header_barre_oblique_element_1_icone_2Alt}
                            onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_1_icone_2Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_mini_header_barre_oblique_element_1_icone_2Opacite}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_1_icone_2Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="icone-1 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_mini_header_barre_oblique_element_2_icone_1Afficher}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_2_icone_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_mini_header_barre_oblique_element_2_icone_1Alt}
                            onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_2_icone_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_mini_header_barre_oblique_element_2_icone_1Opacite}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_2_icone_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_mini_header_barre_oblique_element_2_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_2_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_mini_header_barre_oblique_element_2_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_2_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_mini_header_barre_oblique_element_2_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_2_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="icone-2 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_mini_header_barre_oblique_element_2_icone_2Afficher}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_2_icone_2Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_mini_header_barre_oblique_element_2_icone_2Alt}
                            onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_2_icone_2Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_mini_header_barre_oblique_element_2_icone_2Opacite}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_2_icone_2Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="icone-1 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_mini_header_barre_oblique_element_3_icone_1Afficher}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_3_icone_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_mini_header_barre_oblique_element_3_icone_1Alt}
                            onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_3_icone_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_mini_header_barre_oblique_element_3_icone_1Opacite}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_3_icone_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_mini_header_barre_oblique_element_3_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_3_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_mini_header_barre_oblique_element_3_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_3_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_mini_header_barre_oblique_element_3_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_3_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="icone-2 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_mini_header_barre_oblique_element_3_icone_2Afficher}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_3_icone_2Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_mini_header_barre_oblique_element_3_icone_2Alt}
                            onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_3_icone_2Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_mini_header_barre_oblique_element_3_icone_2Opacite}
                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_3_icone_2Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_1_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_card_1_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_1_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_1_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_1_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_card_1_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_1_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_card_1_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_1_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_1_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_1_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_card_1_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_2_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_card_2_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_2_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_2_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_2_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_card_2_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_2_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_card_2_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_2_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_2_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_2_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_card_2_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_3_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_card_3_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_3_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_3_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_3_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_card_3_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_3_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_card_3_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_3_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_3_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_3_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_card_3_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_4_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_card_4_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_4_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_4_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_4_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_card_4_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_4_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_card_4_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_4_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_4_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_4_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_card_4_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_5_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_card_5_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_5_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_5_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_5_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_card_5_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_5_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_card_5_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_5_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_5_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_5_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_card_5_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_6_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_card_6_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_6_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_6_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_6_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_card_6_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_6_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_card_6_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_6_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_6_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_6_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_card_6_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                {/* id_bloc */}
                {/* id_mini_header */}
                <section className="row">
                    {/* id_mini_header_barre_oblique */}
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            {/* id_mini_header_barre_oblique_element_1 */}
                            <div className="col-lg-4">
                                {/* id_mini_header_barre_oblique_element_1_icone_1 */}
                                {id_mini_header_barre_oblique_element_1_icone_1Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_mini_header_barre_oblique_element_1_icone_1Id: media.id, id_mini_header_barre_oblique_element_1_icone_1Alt: media.alt })}
                                        type="image"
                                        value={id_mini_header_barre_oblique_element_1_icone_1Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_mini_header_barre_oblique_element_1_icone_1ImageUrl ? (
                                                    <img className="id_mini_header_barre_oblique_element_1_icone_1" src={id_mini_header_barre_oblique_element_1_icone_1ImageUrl} alt={id_mini_header_barre_oblique_element_1_icone_1Alt} style={{ opacity: id_mini_header_barre_oblique_element_1_icone_1Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_mini_header_barre_oblique_element_1_icone_1 */}
                                {/* id_mini_header_barre_oblique_element_1_texte_1 */}
                                {id_mini_header_barre_oblique_element_1_texte_1Afficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_mini_header_barre_oblique_element_1_texte_1 " 
                                        value={id_mini_header_barre_oblique_element_1_texte_1Texte} 
                                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_1_texte_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_mini_header_barre_oblique_element_1_texte_1CouleurTexte, opacity: id_mini_header_barre_oblique_element_1_texte_1Opacite }} 
                                    />
                                )}
                                {/* end-id_mini_header_barre_oblique_element_1_texte_1 */}
                                {/* id_mini_header_barre_oblique_element_1_icone_2 */}
                                {id_mini_header_barre_oblique_element_1_icone_2Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_mini_header_barre_oblique_element_1_icone_2Id: media.id, id_mini_header_barre_oblique_element_1_icone_2Alt: media.alt })}
                                        type="image"
                                        value={id_mini_header_barre_oblique_element_1_icone_2Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_mini_header_barre_oblique_element_1_icone_2ImageUrl ? (
                                                    <img className="id_mini_header_barre_oblique_element_1_icone_2" src={id_mini_header_barre_oblique_element_1_icone_2ImageUrl} alt={id_mini_header_barre_oblique_element_1_icone_2Alt} style={{ opacity: id_mini_header_barre_oblique_element_1_icone_2Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_mini_header_barre_oblique_element_1_icone_2 */}
                            </div>
                            {/* end-id_mini_header_barre_oblique_element_1 */}
                            {/* id_mini_header_barre_oblique_element_2 */}
                            <div className="col-lg-4">
                                {/* id_mini_header_barre_oblique_element_2_icone_1 */}
                                {id_mini_header_barre_oblique_element_2_icone_1Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_mini_header_barre_oblique_element_2_icone_1Id: media.id, id_mini_header_barre_oblique_element_2_icone_1Alt: media.alt })}
                                        type="image"
                                        value={id_mini_header_barre_oblique_element_2_icone_1Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_mini_header_barre_oblique_element_2_icone_1ImageUrl ? (
                                                    <img className="id_mini_header_barre_oblique_element_2_icone_1" src={id_mini_header_barre_oblique_element_2_icone_1ImageUrl} alt={id_mini_header_barre_oblique_element_2_icone_1Alt} style={{ opacity: id_mini_header_barre_oblique_element_2_icone_1Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_mini_header_barre_oblique_element_2_icone_1 */}
                                {/* id_mini_header_barre_oblique_element_2_texte_1 */}
                                {id_mini_header_barre_oblique_element_2_texte_1Afficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_mini_header_barre_oblique_element_2_texte_1 " 
                                        value={id_mini_header_barre_oblique_element_2_texte_1Texte} 
                                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_2_texte_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_mini_header_barre_oblique_element_2_texte_1CouleurTexte, opacity: id_mini_header_barre_oblique_element_2_texte_1Opacite }} 
                                    />
                                )}
                                {/* end-id_mini_header_barre_oblique_element_2_texte_1 */}
                                {/* id_mini_header_barre_oblique_element_2_icone_2 */}
                                {id_mini_header_barre_oblique_element_2_icone_2Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_mini_header_barre_oblique_element_2_icone_2Id: media.id, id_mini_header_barre_oblique_element_2_icone_2Alt: media.alt })}
                                        type="image"
                                        value={id_mini_header_barre_oblique_element_2_icone_2Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_mini_header_barre_oblique_element_2_icone_2ImageUrl ? (
                                                    <img className="id_mini_header_barre_oblique_element_2_icone_2" src={id_mini_header_barre_oblique_element_2_icone_2ImageUrl} alt={id_mini_header_barre_oblique_element_2_icone_2Alt} style={{ opacity: id_mini_header_barre_oblique_element_2_icone_2Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_mini_header_barre_oblique_element_2_icone_2 */}
                            </div>
                            {/* end-id_mini_header_barre_oblique_element_2 */}
                            {/* id_mini_header_barre_oblique_element_3 */}
                            <div className="col-lg-4">
                                {/* id_mini_header_barre_oblique_element_3_icone_1 */}
                                {id_mini_header_barre_oblique_element_3_icone_1Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_mini_header_barre_oblique_element_3_icone_1Id: media.id, id_mini_header_barre_oblique_element_3_icone_1Alt: media.alt })}
                                        type="image"
                                        value={id_mini_header_barre_oblique_element_3_icone_1Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_mini_header_barre_oblique_element_3_icone_1ImageUrl ? (
                                                    <img className="id_mini_header_barre_oblique_element_3_icone_1" src={id_mini_header_barre_oblique_element_3_icone_1ImageUrl} alt={id_mini_header_barre_oblique_element_3_icone_1Alt} style={{ opacity: id_mini_header_barre_oblique_element_3_icone_1Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_mini_header_barre_oblique_element_3_icone_1 */}
                                {/* id_mini_header_barre_oblique_element_3_texte_1 */}
                                {id_mini_header_barre_oblique_element_3_texte_1Afficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_mini_header_barre_oblique_element_3_texte_1 " 
                                        value={id_mini_header_barre_oblique_element_3_texte_1Texte} 
                                        onChange={(val) => setAttributes({ id_mini_header_barre_oblique_element_3_texte_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_mini_header_barre_oblique_element_3_texte_1CouleurTexte, opacity: id_mini_header_barre_oblique_element_3_texte_1Opacite }} 
                                    />
                                )}
                                {/* end-id_mini_header_barre_oblique_element_3_texte_1 */}
                                {/* id_mini_header_barre_oblique_element_3_icone_2 */}
                                {id_mini_header_barre_oblique_element_3_icone_2Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_mini_header_barre_oblique_element_3_icone_2Id: media.id, id_mini_header_barre_oblique_element_3_icone_2Alt: media.alt })}
                                        type="image"
                                        value={id_mini_header_barre_oblique_element_3_icone_2Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_mini_header_barre_oblique_element_3_icone_2ImageUrl ? (
                                                    <img className="id_mini_header_barre_oblique_element_3_icone_2" src={id_mini_header_barre_oblique_element_3_icone_2ImageUrl} alt={id_mini_header_barre_oblique_element_3_icone_2Alt} style={{ opacity: id_mini_header_barre_oblique_element_3_icone_2Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_mini_header_barre_oblique_element_3_icone_2 */}
                            </div>
                            {/* end-id_mini_header_barre_oblique_element_3 */}
                        </div>
                    </div>
                    {/* end-id_mini_header_barre_oblique */}
                </section>
                {/* end-id_mini_header */}
                <div className="row">
                    {/* id_card_1 */}
                    <div className="col-12 col-md-6 col-lg-4 col-xl-2">
                        {/* id_card_1_titre_1 */}
                        {id_card_1_titre_1Afficher && (
                            <RichText 
                                tagName="h3" 
                                className="id_card_1_titre_1 " 
                                value={id_card_1_titre_1Texte} 
                                onChange={(val) => setAttributes({ id_card_1_titre_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_1_titre_1CouleurTexte, opacity: id_card_1_titre_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_1_titre_1 */}
                        {/* id_card_1_paragraphe_1 */}
                        {id_card_1_paragraphe_1Afficher && (
                            <RichText 
                                tagName="p" 
                                className="id_card_1_paragraphe_1 " 
                                value={id_card_1_paragraphe_1Texte} 
                                onChange={(val) => setAttributes({ id_card_1_paragraphe_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_1_paragraphe_1CouleurTexte, opacity: id_card_1_paragraphe_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_1_paragraphe_1 */}
                    </div>
                    {/* end-id_card_1 */}
                    {/* id_card_2 */}
                    <div className="col-12 col-md-6 col-lg-4 col-xl-2">
                        {/* id_card_2_titre_1 */}
                        {id_card_2_titre_1Afficher && (
                            <RichText 
                                tagName="h3" 
                                className="id_card_2_titre_1 " 
                                value={id_card_2_titre_1Texte} 
                                onChange={(val) => setAttributes({ id_card_2_titre_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_2_titre_1CouleurTexte, opacity: id_card_2_titre_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_2_titre_1 */}
                        {/* id_card_2_paragraphe_1 */}
                        {id_card_2_paragraphe_1Afficher && (
                            <RichText 
                                tagName="p" 
                                className="id_card_2_paragraphe_1 " 
                                value={id_card_2_paragraphe_1Texte} 
                                onChange={(val) => setAttributes({ id_card_2_paragraphe_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_2_paragraphe_1CouleurTexte, opacity: id_card_2_paragraphe_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_2_paragraphe_1 */}
                    </div>
                    {/* end-id_card_2 */}
                    {/* id_card_3 */}
                    <div className="col-12 col-md-6 col-lg-4 col-xl-2">
                        {/* id_card_3_titre_1 */}
                        {id_card_3_titre_1Afficher && (
                            <RichText 
                                tagName="h3" 
                                className="id_card_3_titre_1 " 
                                value={id_card_3_titre_1Texte} 
                                onChange={(val) => setAttributes({ id_card_3_titre_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_3_titre_1CouleurTexte, opacity: id_card_3_titre_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_3_titre_1 */}
                        {/* id_card_3_paragraphe_1 */}
                        {id_card_3_paragraphe_1Afficher && (
                            <RichText 
                                tagName="p" 
                                className="id_card_3_paragraphe_1 " 
                                value={id_card_3_paragraphe_1Texte} 
                                onChange={(val) => setAttributes({ id_card_3_paragraphe_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_3_paragraphe_1CouleurTexte, opacity: id_card_3_paragraphe_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_3_paragraphe_1 */}
                    </div>
                    {/* end-id_card_3 */}
                    {/* id_card_4 */}
                    <div className="col-12 col-md-6 col-lg-4 col-xl-2">
                        {/* id_card_4_titre_1 */}
                        {id_card_4_titre_1Afficher && (
                            <RichText 
                                tagName="h3" 
                                className="id_card_4_titre_1 " 
                                value={id_card_4_titre_1Texte} 
                                onChange={(val) => setAttributes({ id_card_4_titre_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_4_titre_1CouleurTexte, opacity: id_card_4_titre_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_4_titre_1 */}
                        {/* id_card_4_paragraphe_1 */}
                        {id_card_4_paragraphe_1Afficher && (
                            <RichText 
                                tagName="p" 
                                className="id_card_4_paragraphe_1 " 
                                value={id_card_4_paragraphe_1Texte} 
                                onChange={(val) => setAttributes({ id_card_4_paragraphe_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_4_paragraphe_1CouleurTexte, opacity: id_card_4_paragraphe_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_4_paragraphe_1 */}
                    </div>
                    {/* end-id_card_4 */}
                    {/* id_card_5 */}
                    <div className="col-12 col-md-6 col-lg-4 col-xl-2">
                        {/* id_card_5_titre_1 */}
                        {id_card_5_titre_1Afficher && (
                            <RichText 
                                tagName="h3" 
                                className="id_card_5_titre_1 " 
                                value={id_card_5_titre_1Texte} 
                                onChange={(val) => setAttributes({ id_card_5_titre_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_5_titre_1CouleurTexte, opacity: id_card_5_titre_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_5_titre_1 */}
                        {/* id_card_5_paragraphe_1 */}
                        {id_card_5_paragraphe_1Afficher && (
                            <RichText 
                                tagName="p" 
                                className="id_card_5_paragraphe_1 " 
                                value={id_card_5_paragraphe_1Texte} 
                                onChange={(val) => setAttributes({ id_card_5_paragraphe_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_5_paragraphe_1CouleurTexte, opacity: id_card_5_paragraphe_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_5_paragraphe_1 */}
                    </div>
                    {/* end-id_card_5 */}
                    {/* id_card_6 */}
                    <div className="col-12 col-md-6 col-lg-4 col-xl-2">
                        {/* id_card_6_titre_1 */}
                        {id_card_6_titre_1Afficher && (
                            <RichText 
                                tagName="h3" 
                                className="id_card_6_titre_1 " 
                                value={id_card_6_titre_1Texte} 
                                onChange={(val) => setAttributes({ id_card_6_titre_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_6_titre_1CouleurTexte, opacity: id_card_6_titre_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_6_titre_1 */}
                        {/* id_card_6_paragraphe_1 */}
                        {id_card_6_paragraphe_1Afficher && (
                            <RichText 
                                tagName="p" 
                                className="id_card_6_paragraphe_1 " 
                                value={id_card_6_paragraphe_1Texte} 
                                onChange={(val) => setAttributes({ id_card_6_paragraphe_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_card_6_paragraphe_1CouleurTexte, opacity: id_card_6_paragraphe_1Opacite }} 
                            />
                        )}
                        {/* end-id_card_6_paragraphe_1 */}
                    </div>
                    {/* end-id_card_6 */}
                </div>
                {/* end-id_bloc */}
            </section>
        </>
    );
}